import { injectable, inject } from 'inversify';
import { v4 as uuid } from 'uuid';
import SessionStorageRepository from '@framework/browser/storage/SessionStorageRepository';

const VIEW_SSID_SESSION_STORAGE_KEY = 'viewSsid';

@injectable()
class ViewSsidService {
  constructor(@inject(SessionStorageRepository) private readonly sessionStorageRepo: SessionStorageRepository) {}

  // @ts-ignore TODO: FIN-32798 strictNullChecks
  private currentUserId: number;

  // @ts-ignore TODO: FIN-32798 strictNullChecks
  private currentEntityId: string;

  private getKey = () => {
    return `${ VIEW_SSID_SESSION_STORAGE_KEY }.${ this.currentUserId }.${ this.currentEntityId }`;
  };

  // @ts-ignore TODO: FIN-32798 strictNullChecks
  bindViewSsid = (entityId: string, userId?: number): string => {
    if (!entityId) {
      // eslint-disable-next-line no-console
      console.error('Cannot bind viewSsid, no entityId provided');
      // @ts-ignore TODO: FIN-32798 strictNullChecks
      return;
    }
    // @ts-ignore TODO: FIN-32798 strictNullChecks
    this.currentUserId = userId;
    this.currentEntityId = entityId;
    let viewSsid = this.getViewSsid();

    if (viewSsid) {
      // eslint-disable-next-line no-console
      console.warn(`Warning! Cannot bind viewSsid, it's already binded. Current viewSsid: ${ viewSsid }`);
      // @ts-ignore TODO: FIN-32798 strictNullChecks
      return;
    }

    if (!viewSsid) {
      viewSsid = uuid();
      this.sessionStorageRepo.setItem(this.getKey(), viewSsid);
    }
  };

  // @ts-ignore TODO: FIN-32798 strictNullChecks
  getViewSsid = (): string => {
    if (!this.currentEntityId) {
      // @ts-ignore TODO: FIN-32798 strictNullChecks
      return undefined;
    }

    // @ts-ignore TODO: FIN-32798 strictNullChecks
    return this.sessionStorageRepo.getItem(this.getKey());
  };

  clearViewSsid = () => {
    return this.sessionStorageRepo.removeItem(this.getKey());
  };
}

export default ViewSsidService;
